import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';

import { AccordionItemComponent } from './accordion-item/accordion-item.component';

@Component({
  selector: 'boi-accordion',
  template: '<ng-content></ng-content>'
})
export class AccordionComponent implements AfterContentInit {
  @ContentChildren(AccordionItemComponent) private readonly items: QueryList<AccordionItemComponent>;

  ngAfterContentInit(): void {
    this.subscribeItemToggleEvent();
  }

  private subscribeItemToggleEvent(): void {
    this.items.toArray().forEach((item: AccordionItemComponent) => {
      item.toggle.subscribe(() => {
        this.toggleItem(item);
      });
    });
  }

  private toggleItem(item: AccordionItemComponent): void {
    item.handleToggle();
  }
}
